// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__23yej","buttons":"PendingPaymentAlert_buttons__14NiN"};